import React from 'react';
import './icon.scss';

export const PlaneFlying: React.FC<JSX.IntrinsicElements['svg']> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className,
  direction,
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className || ''} ${direction || ''}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="plane-flying-icon"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill || '#7E8A96'}
        fillRule="evenodd"
        d="M20.233 12.1c.4.3.747.695 1.02 1.16 0 0 .487.85-.847 1.31a5.684 5.684 0 01-3.146 0l-1.161-.28a.5.5 0 010 .16.56.56 0 01-.12.354.379.379 0 01-.292.146.38.38 0 01-.291-.146.56.56 0 01-.12-.354c0-.122.038-.24.107-.33l-4.373-1.05a.512.512 0 01.108.17c.025.066.04.137.04.21 0 .133-.043.26-.12.354a.379.379 0 01-.292.146.379.379 0 01-.29-.146.573.573 0 01-.04-.645.424.424 0 01.207-.179l-.354-.08-.535-.16-.42-.15a.47.47 0 01.143.179.584.584 0 01.054.241.56.56 0 01-.12.354.379.379 0 01-.292.146.379.379 0 01-.29-.146.56.56 0 01-.121-.354c0-.13.04-.253.114-.347a.384.384 0 01.281-.153 11.501 11.501 0 01-2.174-.94L3.763 9.81a1.03 1.03 0 01-.345-.353c-.09-.15-.15-.324-.173-.507l-.585-4 1.103.17 1.524 2.67c.177.303.441.514.741.59l3.64.89L6.234 3l1.359.36c.473.126.914.39 1.284.77l5.764 6c.293.302.645.508 1.021.6l3.294.78c.451.103.883.303 1.277.59zm-17.4 6.85h18.334a.77.77 0 01.589.293c.156.187.244.442.244.707 0 .265-.088.52-.244.707a.77.77 0 01-.59.293H2.834a.77.77 0 01-.589-.293A1.11 1.11 0 012 19.95c0-.265.088-.52.244-.707a.77.77 0 01.59-.293z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default PlaneFlying;
